import React from "react";
import ScrollToTop from "../../Components/Layout/ScrollToTop";
import SupportingHero from "../../Components/SupportingHero/SupportingHero";
import LocationsHero from "../../img/hero3.jpg";
import LocationsContent from "../../Components/Locations/LocationsContent/LocationsContent";
import Container from "../../Components/Layout/Container";
import { Helmet } from "react-helmet";

const Locations = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <link rel="canonical" href="https://getbrentobox.com/locations" />
        <title>Locations | Brento Box - Fresh Meal Prep Made Easy</title>
        <meta
          name="description"
          content="Brento Box is now available in several locations across the Phoenix area. Find a store or gym near you!"
        />
      </Helmet>
      <div>
        <ScrollToTop />
        <SupportingHero
          title="Locations"
          backgroundImage={`url(${LocationsHero})`}
        />
        <Container>
          <LocationsContent />
        </Container>
      </div>
    </>
  );
};

export default Locations;
